import React from "react";
import "devextreme/data/odata/store";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ToolTip from "../ui/ToolTip";
import OneMonth from "./OneMonth";
import MonthTotals from "./MonthTotals";

class MonthlySetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feeEmpty: this.props.feeEmpty ? this.props.feeEmpty : false,
      budgetttt: "",
      netState: "rgb(0,40,85)",
      showFilterRow: true,
      showHeaderFilter: false,
      rowAlternationEnabled: true,
      showModal: false,
      showEditModal: false,
      janSetup: "",
      febSetup: "",
      marSetup: "",
      aprSetup: "",
      maySetup: "",
      junSetup: "",
      julSetup: "",
      augSetup: "",
      sepSetup: "",
      octSetup: "",
      novSetup: "",
      decSetup: "",
      janPositionsSetup: "",
      febPositionsSetup: "",
      marPositionsSetup: "",
      aprPositionsSetup: "",
      mayPositionsSetup: "",
      junPositionsSetup: "",
      julPositionsSetup: "",
      augPositionsSetup: "",
      sepPositionsSetup: "",
      octPositionsSetup: "",
      novPositionsSetup: "",
      decPositionsSetup: "",
      showUnitPositionSampling: this.props.showUnitPositionSampling
        ? this.props.showUnitPositionSampling
        : false,
      positionsData: this.props.positionsData,
      submediaState: this.props.submediaState,
      budgetDetailsData: this.props.budgetDetailsData
        ? this.props.budgetDetailsData
        : null,
      nbrToHide: this.props.nbrOfMnthToHide ? this.props.nbrOfMnthToHide : null,
      net1: 0,
      technical_cost1: 0,
      fee_value1: 0,
      units01: 0,
      isLC1: false,
      net2: 0,
      technical_cost2: 0,
      fee_value2: 0,
      units02: 0,
      isLC2: false,
      net3: 0,
      technical_cost3: 0,
      fee_value3: 0,
      units03: 0,
      isLC3: false,
      net4: 0,
      technical_cost4: 0,
      fee_value4: 0,
      units04: 0,
      isLC4: false,
      net5: 0,
      technical_cost5: 0,
      fee_value5: 0,
      units05: 0,
      isLC5: false,
      net6: 0,
      technical_cost6: 0,
      fee_value6: 0,
      units06: 0,
      isLC6: false,
      net7: 0,
      technical_cost7: 0,
      fee_value7: 0,
      units07: 0,
      isLC7: false,
      net8: 0,
      technical_cost8: 0,
      fee_value8: 0,
      units08: 0,
      isLC8: false,
      net9: 0,
      technical_cost9: 0,
      fee_value9: 0,
      units09: 0,
      isLC9: false,
      net10: 0,
      technical_cost10: 0,
      fee_value10: 0,
      units010: 0,
      isLC10: false,
      net11: 0,
      technical_cost11: 0,
      fee_value11: 0,
      units011: 0,
      isLC11: false,
      net12: 0,
      technical_cost12: 0,
      fee_value12: 0,
      units012: 0,
      isLC12: false,
      absoluteFees1: 0,
      absoluteFees2: 0,
      absoluteFees3: 0,
      absoluteFees4: 0,
      absoluteFees5: 0,
      absoluteFees6: 0,
      absoluteFees7: 0,
      absoluteFees8: 0,
      absoluteFees9: 0,
      absoluteFees10: 0,
      absoluteFees11: 0,
      absoluteFees12: 0,

      finalcost1: 0,
      finalcost2: 0,
      finalcost3: 0,
      finalcost4: 0,
      finalcost5: 0,
      finalcost6: 0,
      finalcost7: 0,
      finalcost8: 0,
      finalcost9: 0,
      finalcost10: 0,
      finalcost11: 0,
      finalcost12: 0,
      Positions1: [],
      Positions2: [],
      Positions3: [],
      Positions4: [],
      Positions5: [],
      Positions6: [],
      Positions7: [],
      Positions8: [],
      Positions9: [],
      Positions10: [],
      Positions11: [],
      Positions12: [],

      total_net: 0,
      total_technical_cost: 0,
      total_fee_calculated: 0,
      total_final_cost: 0,
      total_units: 0,
      editOptionsYears: this.props.editOptionsYears
        ? this.props.editOptionsYears
        : null,
    };

    this.budgetListNameRef = React.createRef();
    this.mon1 = React.createRef();
    this.mon2 = React.createRef();
    this.mon3 = React.createRef();
    this.mon4 = React.createRef();
    this.mon5 = React.createRef();
    this.mon6 = React.createRef();
    this.mon7 = React.createRef();
    this.mon8 = React.createRef();
    this.mon9 = React.createRef();
    this.mon10 = React.createRef();
    this.mon11 = React.createRef();
    this.mon12 = React.createRef();
    this.totalmonths = React.createRef();
  }

  selectedChanged(e) {
    this.setState({
      selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0]),
    });
  }

  componentDidUpdate() {
    var showUnitPositionSampling_new = this.props.showUnitPositionSampling;
    if (this.state.showUnitPositionSampling != showUnitPositionSampling_new) {
      this.setState({ showUnitPositionSampling: showUnitPositionSampling_new });
    } 
        const weirdval = this.mon1.current.state.net;
  console.log("my state value of the first month:", weirdval)
  }

  hideLines(fromRefresh) {
    const nbrToHide = this.props.updateNbrOfMnthToHide();

    const monRefs = [
      this.mon1,
      this.mon2,
      this.mon3,
      this.mon4,
      this.mon5,
      this.mon6,
      this.mon7,
      this.mon8,
      this.mon9,
      this.mon10,
      this.mon11,
      this.mon12,
    ];

    let m = 0;
    while (m < 12) {
      monRefs[m].current.setState({ hideValue: false });
      m++;
    }

    if (nbrToHide === 0) return;

    let j = 0;

    while (j < nbrToHide) {
      monRefs[j].current.setState({ hideValue: true });
      fromRefresh && monRefs[j].current.cleanupPositions();
      j++;
    }
    return;
  }

  getValidation() {
    let netValidation = {
      //getting all 12 months values: net, fee and technical cost 
      netVal: this.state.total_net,
      technicalVal: this.state.total_technical_cost,
      feeVal: this.state.total_fee_calculated,
      n1: this.mon1.current.state.net,
      n2: this.mon2.current.state.net,
      n3: this.mon3.current.state.net,
      n4: this.mon4.current.state.net,
      n5: this.mon5.current.state.net,
      n6: this.mon6.current.state.net,
      n7: this.mon7.current.state.net,
      n8: this.mon8.current.state.net,
      n9: this.mon9.current.state.net,
      n10: this.mon10.current.state.net,
      n11: this.mon11.current.state.net,
      n12: this.mon12.current.state.net,
      t1: this.mon1.current.state.technical_cost,
      t2: this.mon2.current.state.technical_cost,
      t3: this.mon3.current.state.technical_cost,
      t4: this.mon4.current.state.technical_cost,
      t5: this.mon5.current.state.technical_cost,
      t6: this.mon6.current.state.technical_cost,
      t7: this.mon7.current.state.technical_cost,
      t8: this.mon8.current.state.technical_cost,
      t9: this.mon9.current.state.technical_cost,
      t10: this.mon10.current.state.technical_cost,
      t11: this.mon11.current.state.technical_cost,
      t12: this.mon12.current.state.technical_cost,
      f1: this.mon1.current.state.fee_value,
      f2: this.mon2.current.state.fee_value,
      f3: this.mon3.current.state.fee_value,
      f4: this.mon4.current.state.fee_value,
      f5: this.mon5.current.state.fee_value,
      f6: this.mon6.current.state.fee_value,
      f7: this.mon7.current.state.fee_value,
      f8: this.mon8.current.state.fee_value,
      f9: this.mon9.current.state.fee_value,
      f10: this.mon10.current.state.fee_value,
      f11: this.mon11.current.state.fee_value,
      f12: this.mon12.current.state.fee_value,
    };
  
    const monthRefs = [
      this.mon1, this.mon2, this.mon3, this.mon4, this.mon5, this.mon6,
      this.mon7, this.mon8, this.mon9, this.mon10, this.mon11, this.mon12
    ];
  
    // Create an array of promises to wait for each validation to finish
    const validationPromises = monthRefs.map((monthRef, index) => {
      return new Promise((resolve) => {
        if (monthRef && monthRef.current) {
          monthRef.current.validatePositions((updatedPositionsArray) => {
            // Check if updatedPositionsArray is defined and is an array before calling every
            if (Array.isArray(updatedPositionsArray)) {
              const isMonthValid = updatedPositionsArray.every(pos => pos.isValid);
              console.log(`Are positions valid for month ${index + 1}?`, isMonthValid);
              resolve(isMonthValid); // Resolve with the result of validation
            } else {
              console.warn(`Invalid positions array for month ${index + 1}`);
              resolve(true);
            }
          });
        } else {
          resolve(true);
        }
      });
    });
  
    // Wait for all validations to finish
    return Promise.all(validationPromises).then((results) => {
      const isPositionsValid = results.every(isValid => isValid);
      console.log("Are all positions valid?", isPositionsValid);
  
      // Update netState based on total_net
      if (this.state.total_net === 0) {
        this.setState({ netState: "red" });
      } else {
        this.setState({ netState: "rgb(0,40,85)" });
      }
  
      return { ...netValidation, isPositionsValid };
    });
  }
  

  //to reset and cleanup positions values if we change media
  cleanupPositions() {

    if(this.mon1.current.monthPos.current){
      this.mon1.current.cleanupPositions();
    }
    if(this.mon2.current.monthPos.current){
      this.mon2.current.cleanupPositions();
    }
    if(this.mon3.current.monthPos.current){
      this.mon3.current.cleanupPositions();
    }
    if(this.mon4.current.monthPos.current){
      this.mon4.current.cleanupPositions();
    }
    if(this.mon5.current.monthPos.current){
      this.mon5.current.cleanupPositions();
    }
    if(this.mon6.current.monthPos.current){
      this.mon6.current.cleanupPositions();
    }
    if(this.mon7.current.monthPos.current){
      this.mon7.current.cleanupPositions();
    }
    if(this.mon8.current.monthPos.current){
      this.mon8.current.cleanupPositions();
    }
    if(this.mon9.current.monthPos.current){
      this.mon9.current.cleanupPositions();
    }
    if(this.mon10.current.monthPos.current){
      this.mon10.current.cleanupPositions();
    }
    if(this.mon11.current.monthPos.current){
      this.mon11.current.cleanupPositions();
    }
    if(this.mon12.current.monthPos.current){
      this.mon12.current.cleanupPositions();
    }

    this.setState({
      Positions1: [],
      Positions2: [],
      Positions3: [],
      Positions4: [],
      Positions5: [],
      Positions6: [],
      Positions7: [],
      Positions8: [],
      Positions9: [],
      Positions10: [],
      Positions11: [],
      Positions12: [],
    });
  }
  componentDidMount() {
    this.hideLines();

    if (
      this.state.budgetDetailsData != null &&
      this.state.budgetDetailsData.budgetDetails != undefined &&
      this.state.budgetDetailsData.budgetDetails.length > 0
    ) {
      this.state.budgetDetailsData.budgetDetails.map((budgetDetailsInfo) => {
        for (let i = 1; i <= 12; i++) {
          const monthNumber = i >= 10 ? i.toString() : `0${i}`;
          //making all variables dynamic
          const net_dynamic = `net${i}`;
          const finalCost_dynamic = `finalCost${i}`;
          const technical_cost_dynamic = `technical_cost${i}`;
          const technicalCost_dynamic = `technicalCost${i}`;
          const fees_dynamic = `fees${i}`;
          const fee_value_dynamic = `fee_value${i}`;
          const absoluteFees_dynamic = `absoluteFees${i}`;
          // const units_dynamic = `units${i}`;
          const units_dynamic = `units${monthNumber}`;
          const sampling_dynamic = `sampling${monthNumber}`
          
    
          //checking if we have a position on this month
          if (budgetDetailsInfo.positionId === null) {
            //checking if we have a net on this month
              if ( isEntered(budgetDetailsInfo[finalCost_dynamic])) {
              //updating our net state with the latest values
              this.setState({
                [net_dynamic]: budgetDetailsInfo[net_dynamic],
                [technical_cost_dynamic]: budgetDetailsInfo[technicalCost_dynamic],
                [fee_value_dynamic]: budgetDetailsInfo[fees_dynamic],
                [absoluteFees_dynamic]: budgetDetailsInfo[absoluteFees_dynamic],
                [`isLC${i}`]:
                  Number(budgetDetailsInfo[fees_dynamic]) === 0 &&
                  Number(budgetDetailsInfo[absoluteFees_dynamic]) > 0,
                [units_dynamic]: budgetDetailsInfo[units_dynamic],
                [`finalcost${i}`]: budgetDetailsInfo[finalCost_dynamic],
              });
            }
          } else if (budgetDetailsInfo.positionId !== null) {
            //incase we have a position on this month
              if (isEntered(budgetDetailsInfo[finalCost_dynamic]) ) {
              const positionsNew = this.state[`Positions${i}`];
              const positionData = {
                id: budgetDetailsInfo.budgetDetailId,
                final_cost: budgetDetailsInfo[finalCost_dynamic],
                technical_cost: budgetDetailsInfo[technicalCost_dynamic],
                net: budgetDetailsInfo[net_dynamic],
                fee_calculated: budgetDetailsInfo[absoluteFees_dynamic],
                isLC:
                  Number(budgetDetailsInfo[fees_dynamic]) === 0 &&
                  Number(budgetDetailsInfo[absoluteFees_dynamic]) > 0,
                positionId: budgetDetailsInfo.positionId,
                units: budgetDetailsInfo[units_dynamic],
                isSampling: budgetDetailsInfo[sampling_dynamic],
                // If LC (absolute fees) use the absolute value for display in fee_value so the input shows the amount
                fee_value:
                  Number(budgetDetailsInfo[fees_dynamic]) === 0 &&
                  Number(budgetDetailsInfo[absoluteFees_dynamic]) > 0
                    ? budgetDetailsInfo[absoluteFees_dynamic]
                    : budgetDetailsInfo[fees_dynamic],
              };
              positionsNew.push(positionData);
    
              //here incase we have more than 1 position, we calculate there total
              let total_net = 0;
              let total_technical_cost = 0;
              let total_final_cost = 0;
              let total_fee_calculated = 0;
    
              positionsNew.map((position) => {
                total_fee_calculated += parseFloat(position.fee_calculated);
                total_net += parseFloat(position.net);
                total_technical_cost += parseFloat(position.technical_cost);
                total_final_cost += parseFloat(position.final_cost);
              });

            
              //finaly updating our position state with the latest values
              this.setState({
                [`Positions${i}`]: positionsNew,
                showUnitPositionSampling: true,
                [net_dynamic]: total_net,
                [`absoluteFees${i}`]: total_fee_calculated,
                [`finalcost${i}`]: total_final_cost,
                [`technicalCost${i}`]: total_technical_cost,
              });
            }
          }
        }
      });
    }
  }

  calculateTotalsOnValueChange() {

  const monthRefs = [
    this.mon1, this.mon2, this.mon3, this.mon4, this.mon5, this.mon6,
    this.mon7, this.mon8, this.mon9, this.mon10, this.mon11, this.mon12
  ];

  let totalMonthsNet = 0;
  let totalTechnicalCost = 0;
  let totalFeesCalculatted = 0;
  let totalFinalCost = 0;
  let totalUnits = 0;

  monthRefs.forEach(ref => {

    // Si le composant enfant n'est pas monté → on considère des 0
    const state = ref?.current?.state || {};

    // On parse en blindant tous les champs (null/undefined → 0)
    const net = parseFloat(state.net ?? 0) || 0;
    const technicalCost = parseFloat(state.technical_cost ?? 0) || 0;
    const feeCalculated = parseFloat(state.fee_calculated ?? 0) || 0;
    const finalCost = parseFloat(state.final_cost ?? 0) || 0;
    const units = parseFloat(state.units ?? 0) || 0;

    totalMonthsNet += net;
    totalTechnicalCost += technicalCost;
    totalFeesCalculatted += feeCalculated;
    totalFinalCost += finalCost;
    totalUnits += units;
  });

  this.setState({
    total_technical_cost: totalTechnicalCost,
    total_net: totalMonthsNet,
    total_fee_calculated: totalFeesCalculatted.toFixed(4),
    total_final_cost: totalFinalCost,
    total_units: totalUnits,
  });
}



  setupChanged(nbr, shortcut, budgetdetails) {
    var emptyValue = `"Net${nbr}": 0
      ,"TechnicalCost${nbr}": 0 
      ,"Fees${nbr}": 0
      ,"FinalCost${nbr}": 0
      ,"AbsoluteFees${nbr}": 0
    `;

    // incase we have empty or zero values we make all the Json file empty array
    if (
      this.state[`${shortcut}Setup`].replaceAll(" ", "") === emptyValue.replaceAll(" ", "") ||
      budgetdetails.replaceAll(" ", "") === emptyValue.replaceAll(" ", "")
    ) {
      budgetdetails = "";
    }
    this.setState({ [`${shortcut}Setup`]: budgetdetails }, this.returnMonthSetup);
    // setTimeout(() => {
      console.log("i am inside setupChanged")
      this.calculateTotalsOnValueChange();
    // }, 50); 
  }

  positionsSetupChanged (shortcut ,positionDetail){
    this.setState({ [`${shortcut}PositionsSetup`]: positionDetail }, this.returnMonthSetup);
    setTimeout(() => {
      console.log("i am inside positionsSetupChanged")
      this.calculateTotalsOnValueChange();
    }, 100); 
    
  };


  returnMonthSetup() {
    const monthNumbers = [
      "jan", "feb", "mar", "apr", "may", "jun",
      "jul", "aug", "sep", "oct", "nov", "dec"
    ];
  
    //making a new fresh and updated Json after every onChange function
    let allBudgetDetails = '{"BudgetDetails":[{';
    let netSet = false;
  
    monthNumbers.forEach((month, index) => {
      const setup = this.state[`${month}Setup`];
      // const positionsSetup = this.state[`${month}PositionsSetup`];
  
      if (setup) {
        allBudgetDetails += setup;
        if (index < monthNumbers.length - 1) {
          allBudgetDetails += ",";
        }
        netSet = true;
      }
    });
    if (netSet) {
    allBudgetDetails = allBudgetDetails.slice(0, -1);
    allBudgetDetails += "},";
    }else{
      allBudgetDetails = allBudgetDetails.slice(0, -1);
    }
    monthNumbers.forEach((month, index) => {
      // const setup = this.state[`${month}Setup`];
      const positionsSetup = this.state[`${month}PositionsSetup`];
      if (positionsSetup) {
        allBudgetDetails += positionsSetup;
        if (index <= monthNumbers.length - 1) {
          allBudgetDetails += ",";
        }
      }
    });

    allBudgetDetails = allBudgetDetails.slice(0, -1);
    allBudgetDetails += "]}";
  
    console.log("*****Final Budget Result!*****", allBudgetDetails);
    this.props.data.setupChanged(allBudgetDetails);
    this.setState({ budgetttt: allBudgetDetails });
  }

  render() {
    
    const color = this.state.netState === "red" ? "red" : "black";


    const months = [
      { monthNumber: "1", monthname: "January", shortcut: "jan" },
      { monthNumber: "2", monthname: "February", shortcut: "feb" },
      { monthNumber: "3", monthname: "March", shortcut: "mar" },
      { monthNumber: "4", monthname: "April", shortcut: "apr" },
      { monthNumber: "5", monthname: "May", shortcut: "may" },
      { monthNumber: "6", monthname: "June", shortcut: "jun" },
      { monthNumber: "7", monthname: "July", shortcut: "jul" },
      { monthNumber: "8", monthname: "August", shortcut: "aug" },
      { monthNumber: "9", monthname: "September", shortcut: "sep" },
      { monthNumber: "10", monthname: "October", shortcut: "oct" },
      { monthNumber: "11", monthname: "November", shortcut: "nov" },
      { monthNumber: "12", monthname: "December", shortcut: "dec" }
    ];

    return (
      <div className="div-monthly-setup-container">
        <div className="div-section-actions push"></div>
        <div
          className={`${
            this.state.netState === "red"
              ? "div-monthly-setup-container-header padding-bot"
              : "div-monthly-setup-container-header"
          }`}
        >
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col1"></div>
          <div
            className="div-monthly-setup-container-cell div-monthly-setup-container-col2 budget-title"
          >
            <span className="budget-title-span" >
              {"Net"}
            </span>

            <ToolTip
              title="Please fill in here the net media spend – meaning to reflect the vendors invoice rate, purely space buying without taxes."
              color={this.state.netState}
            />
            {this.state.netState === "red" && (
              <p className="p-error">
                At least one month must have a value defined
              </p>
            )}
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col3 budget-title-2">
            <span className="budget-title-span" >
              {"Technical Cost"}
            </span>
            <ToolTip title="Please fill in here all non purely media costs such as Ad serving, IAS or other BAV tool, or related costs or production costs or any other technical costs linked to the media buying." />
          </div>
          <div
            className="div-monthly-setup-container-cell div-monthly-setup-container-col4 min-w-170"
          ></div>{" "}
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col5 budget-title">
            <span className="budget-title-span" >
              {"Fee (% or LC)"}
            </span>
            <ToolTip title="Please fill in the fee accordingly to your Agency’s remuneration model. The suggested fee will detect the commission you should apply. Should you be on a fee or retainer please enter the related value." />
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col6 budget-title-3">
            <span className="budget-title-span-2">
              {"Fee (Calculated)"}
            </span>
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col7 budget-title-4">
            <span className="budget-title-span" >
              {"Final Cost"}
            </span>
            <ToolTip title="This automatically sums up the previous to give the global cost for the media buying." />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell unit-position-sample"
                : "hidden"
            }
          >
            <span className="budget-title-span" >
              {"Units"}
            </span>
            <ToolTip title="Please enter the number of insertions for the selected position. If you don’t know them yet, leave 0" />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell unit-position-sample"
                : "hidden"
            }
          >
            <span className="budget-title-span" >
              {"Sampling"}
            </span>
            <ToolTip title="Please tick the box if the insertion contains sampling" />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell unit-position-sample"
                : "hidden"
            }
            style={{ justifyContent: "center" }}
          >
            <span className="budget-title-span" >
              {"Positions"}
            </span>
            <ToolTip title="The Position related to the campaign. This should be input in the Month of the parution of the Vehicle. If there are multiple positions per Month, you can create a new line for this Month." />
          </div>
        </div>


        {months.map((month, index) => (
            <OneMonth
              key={index}
              ref={this[`mon${month.monthNumber}`]}
              submediaState={this.props.submediaState}
              data={{
                monSetupChanged: (budgetdetails) => this.setupChanged(month.monthNumber, month.shortcut, budgetdetails),
                positionSetupChanged: (budgetdetails) => this.positionsSetupChanged(month.shortcut, budgetdetails),
              }}
              monthNumber={month.monthNumber}
              monthname={month.monthname}
              showUnitPositionSampling={this.state.showUnitPositionSampling}
              positionsData={this.props.positionsData}
              positionsArray={this.state[`Positions${month.monthNumber}`]}
              net={this.state[`net${month.monthNumber}`]}
              technical_cost={this.state[`technical_cost${month.monthNumber}`]}
              fee_value={
                this.state[`isLC${month.monthNumber}`]
                  ? this.state[`absoluteFees${month.monthNumber}`]
                  : this.state[`fee_value${month.monthNumber}`]
              }
              units={month.monthNumber >= 10 ? this.state[`units${month.monthNumber}`] : this.state[`units0${month.monthNumber}`]}
              isLC={this.state[`isLC${month.monthNumber}`]}
              fee_calculated={
                this.state[`isLC${month.monthNumber}`]
                  ? this.state[`absoluteFees${month.monthNumber}`]
                  : (this.state[`fee_value${month.monthNumber}`] * this.state[`net${month.monthNumber}`]) / 100
              }
              final_cost={this.state[`finalcost${month.monthNumber}`]}
            />
          ))}

            
        <MonthTotals
          ref={this.totalmonths}
          monthname="Yearly Totals"
          showUnitPositionSampling={this.state.showUnitPositionSampling}
          net={this.state.total_net}
          technical_cost={this.state.total_technical_cost}
          units={this.state.total_units}
          fee_calculated={this.state.total_fee_calculated}
          final_cost={this.state.total_final_cost}
        />
      </div>
    );
  }
}

function isEntered(val) {
  return (
    val !== null &&
    val !== undefined &&
    !(typeof val === "string" && val.trim() === "") &&
    !isNaN(Number(val)) &&
    Number(val) !== 0
  );
}
export default MonthlySetup;
